import React, { useState, useEffect } from 'react'
import { useSupplierFormContext } from '../hook/supplier-form'
import { useFormClientSupplier } from '../schema/form'
import { Box, Paper, Text, Flex, Button, Table, Modal, Select, Group, Avatar, Loader, FocusTrap } from '@mantine/core'
import { IconCheck } from '@tabler/icons-react'
import NoData from '../../../ui/NoData'
import { getListUserExcludeAdmin } from '../../../../services/users'
import { useDebouncedCallback } from '@mantine/hooks'

const labelTable = [
  {
    label: 'Name',
    width: 'auto'
  },
  {
    label: 'Email',
    width: 'auto'
  },
  {
    label: 'Phone',
    width: 'auto'
  },
  {
    label: 'Type',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 50
  },
]

const defaultTypeUser = [
  {
    value: 'admin',
    label: 'Admin'
  },
  {
    value: 'customer',
    label: 'Customer'
  },
]

const UserListSupplier = () => {
  const form = useSupplierFormContext()
  const formUser = useFormClientSupplier()
  const [modalAddClient, setModalAddClient] = useState(false)
  
  const [loadingClient, setLoadingClient] = useState(true)
  const [clientList, setClientList] = useState([])
  const [searchClient, setSearchClient] = useState('')

  const handleGetClientList = useDebouncedCallback(async () => {
    setLoadingClient(true)
    const parameter = {
      'filter[name][like]': searchClient,
      'fields[user]': 'id,name,email,phone,active',
      'page[num]': 1,
      'page[limit]': 20
    }
    try {
      const response = await getListUserExcludeAdmin(parameter)
      const dataUser = response.data
      const remapData = dataUser.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
          email: val.attributes.email,
          phone: val.attributes.phone
        }
      })
      setClientList(remapData)
    } catch (error) {
      console.log(error)
    }finally {
      setLoadingClient(false)
    }
  }, 300)

  useEffect(() => {
    handleGetClientList()
    // eslint-disable-next-line
  }, [searchClient])

  const onCloseModalClient = () => {
    setSearchClient('')
    formUser.reset()
    setModalAddClient(false)
  }

  const handleAddUser = (formClient) => {
    const findData = clientList.find((val) => val.value === formClient.id)
    if (findData) {
      const payloadUser = {
        id: findData.value,
        name: findData.label,
        email: findData.email,
        phone: findData.phone,
        type: formClient.type
      }
      form.insertListItem('users', payloadUser)
      onCloseModalClient()
    }
  }

  const handleRemoveUser = (indexUser) => {
    form.removeListItem('users', indexUser)
  }

  const renderUserOption = ({ option, checked }) => {
    return (
      <Group flex="1" align='center' gap="xs">
        <Flex gap='sm' align='center'>
          <Avatar variant='filled' name={option.label} radius="xl" size="sm" color='red' />
          <Box>
            <Text fz={12} fw='600' lineClamp={2}>{option.label}</Text>
            <Text fz={10} fw='500' c='gray.6' lineClamp={2}>{option.email}</Text>
          </Box>
        </Flex>
        {checked && <IconCheck style={{ marginInlineStart: 'auto' }} />}
      </Group>
    )
  }

  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  const mappingDataUsers = () => {
    const userList = form.getValues().users
    if (userList.length > 0) {

      const mappingTableHead = (data) => data.map((val, index) => {
        return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
      })

      const mappingDataTable = (data) => data.map((val, index) => {
        return (
          <Table.Tr key={index}>
          <Table.Td>{val.name}</Table.Td>
          <Table.Td>{val.email ? val.email : '-'}</Table.Td>
          <Table.Td>{val.phone ? val.phone : '-'}</Table.Td>
          <Table.Td tt='capitalize'>{val.type}</Table.Td>
          <Table.Td>
            <Button size='compact-xs' fz={10} onClick={() => handleRemoveUser(index)}>Delete</Button>
          </Table.Td>
        </Table.Tr>
        )
      })

      return (
        <Table.ScrollContainer type='native'>
          <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
            <Table.Thead style={{ backgroundColor: '#eeefef' }}>
              <Table.Tr>
                {mappingTableHead(labelTable)}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody style={{ verticalAlign: 'top' }}>
              {mappingDataTable(userList)}
            </Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      )
    } else {
      return (
        <NoData />
      )
    }
  }


  return (
    <Box>
      <Paper shadow="xs" radius="md" withBorder p="sm" mb='md'>
        <Text fz={14} fw='bold' mb='sm'>User List</Text>
        <Flex justify='flex-end'>
          <Button size='xs' variant="filled" onClick={() => setModalAddClient(true)}>Add User</Button>
        </Flex>
        <Box my={10}>
          {mappingDataUsers()}
        </Box>
      </Paper>
      <Modal size='md' opened={modalAddClient} centered closeOnClickOutside={false} withCloseButton={false} onClose={() => onCloseModalClient()} title="Add User">
        <Box>
          <FocusTrap.InitialFocus />
          <Box mb='sm'>
            <Select
              name='id'
              label='User'
              data={clientList}
              renderOption={renderUserOption}
              key={formUser.key('id')}
              {...formUser.getInputProps('id')}
              size='xs'
              searchable
              searchValue={searchClient}
              onSearchChange={setSearchClient}
              nothingFoundMessage={!loadingClient ? clientList.length > 0 ? '' : 'No User Found' : loadingDataTemplate()}
              clearable
              allowDeselect={false}
            />
          </Box>
          <Box mb='sm'>
            <Select
              name='type'
              label='Type'
              data={defaultTypeUser}
              key={formUser.key('type')}
              {...formUser.getInputProps('type')}
              size='xs'
              allowDeselect={false}
            />
          </Box>
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={() => onCloseModalClient()}>Close</Button>
              <Button size='xs' variant="filled" onClick={formUser.onSubmit((value) => handleAddUser(value))}>Add</Button>
            </Group>
          </Flex>
        </Box>
      </Modal>
    </Box>
  )
}

export default UserListSupplier